import { render, staticRenderFns } from "./po_ord.vue?vue&type=template&id=dd6bbfaa&scoped=true&"
import script from "./po_ord.vue?vue&type=script&lang=js&"
export * from "./po_ord.vue?vue&type=script&lang=js&"
import style0 from "./po_ord.vue?vue&type=style&index=0&id=dd6bbfaa&scoped=true&lang=less&"
import style1 from "./po_ord.vue?vue&type=style&index=1&lang=less&"
import style2 from "./po_ord.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6bbfaa",
  null
  
)

export default component.exports